export const emailPatternRegExp = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
